export default __webpack_public_path__ + "static/media/close.017607c4.svg";